export default __webpack_public_path__ + "static/videoN1-dcc36b828740544f6b0fc2627daf5573.webp";